var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('h2',[_vm._v(_vm._s(_vm.$t('pages.contact.title')))]),_vm._v(" "),_c('image-block',{attrs:{"image-url":_vm.image.imageUrl,"title":_vm.image.title,"text":_vm.image.text}}),_vm._v(" "),_c('form-type',{attrs:{"parts":_vm.parts,"schema":_vm.contact,"post-uri":_vm.postUri,"success_route":{ name: 'home' }}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9c88e88","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Default/Contact.vue
// module id = 970
// module chunks = 1